import type { ReactNode } from 'react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetHeaderDescription,
  ModalSheetTitle,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'

export interface SelectionEditorDialogProps {
  title: ReactNode
  description: ReactNode
  showing: boolean
  onClose: () => unknown
  /**
   * Should be the SelectionList.
   */
  children?: ReactNode
}

export function SelectionEditorDialog({
  showing,
  onClose,
  title,
  children,
  description,
}: SelectionEditorDialogProps) {
  return (
    <ModalSheet showing={showing} onRequestClose={onClose}>
      <ModalSheetHeader withCloseButton bordered>
        <ModalSheetTitle>{title}</ModalSheetTitle>
        <ModalSheetHeaderDescription>{description}</ModalSheetHeaderDescription>
      </ModalSheetHeader>
      <ModalSheetContent leftAligned>{children}</ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button label="Close" onPress={onClose} />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
